var seat_styles = {
    available: {
        normal : {
            fill: "#fff",
            fillOpacity: 0.1,
            stroke: "#fff",
            strokeOpacity: 0.6
        },
        hover : {
            fill: "#fff",
            fillOpacity: 0.8,
            stroke: "#fff",
            strokeOpacity: 1
        },
    },
    selected: {
        normal : {
            fill: "#1f8efa",
            fillOpacity: 1,
            stroke: "#fff",
            strokeOpacity: 1
        },
        hover : {
            fill: "#cce6ff",
            fillOpacity: 0.8,
            stroke: "#1f8efa",
            strokeOpacity: 1
        },
    },
    unavailable: {
        fill: "#fff",
        fillOpacity: 0,
        stroke: "#fff",
        strokeOpacity: 0
    }
}

var viewer, viewer_mini, viewer_3d;
var minimap_load = null;
var popover_timeout = null;

function dvmSetInitialFlags(){
    viewer.flags.fixed_aspect_ratio = false;
    viewer.flags.automatic_selection = false;
    viewer_mini.flags.fixed_aspect_ratio = false;
    viewer_mini.flags.automatic_selection = false;
    viewer_3d.flags.fixed_aspect_ratio = false;
    viewer_3d.gallery.flags.show_gallery_button = false;
    if(interfaceIsMobile()){
        viewer_3d.interface.setLabelOffset(10,4);
    }else{
        viewer_3d.interface.setLabelOffset(20,7);

    }
    return false;
}

function dvmBindInterfaceEvents(){
    var zoom_in_btn = document.getElementsByClassName("zoom-in-btn")[0];
    var zoom_out_btn = document.getElementsByClassName("zoom-out-btn")[0];

    viewer.bindInterfaceAction(zoom_in_btn, "zoom-in");
    viewer.bindInterfaceAction(zoom_out_btn, "zoom-out");

    var move_left_btn = document.getElementById("move-left");
    var move_right_btn = document.getElementById("move-right");
    var move_up_btn = document.getElementById("move-up");
    var move_down_btn = document.getElementById("move-down");

    viewer.bindInterfaceAction(move_left_btn, "move-left");
    viewer.bindInterfaceAction(move_right_btn, "move-right");
    viewer.bindInterfaceAction(move_up_btn, "move-up");
    viewer.bindInterfaceAction(move_down_btn, "move-down");

    if(interfaceIsMobile()) {
        dropDownMakerArray("#sections-mobile", Object.keys(manifest.responseJSON), null);
    } else {
        dropDownMakerArray("#sections", Object.keys(manifest.responseJSON), null);
    }

    return null;
}

function dvmStart(config){
    if(interf.params.v360){
        const node = {id: interf.params.v360};
        dvmLoadViewer3D(node);
        interfacesetViewer3D(node);
    }else{
        viewer.loadMap({ venue_id: config.venue_id, map_id: config.topview_id })
            .then(onLoadD2MSuccess)
            .catch(onLoadD2MError);
    }

    minimap_load = viewer_mini.loadMap({ venue_id: config.venue_id, map_id: config.map_id_mini })
        .then(onLoadMinimapSuccess)
        .catch(onLoadD2MError);
    
    return null;
}

function onEnterCB(obj) {
    if(!interfaceIsMobile() && obj.nodes[0].state!='unavailable'){
        popover_timeout = setTimeout(function(){
            popoverOpen(obj);
            popover_timeout = null;
        },100);
    }
    return null;
}

function onLeaveCB(obj) {
    if(!interfaceIsMobile()){
        if(popover_timeout) {
            clearTimeout(popover_timeout);
            popover_timeout = null;
        }
        else{
            popoverDestroyAll();
        }
    }
    return null;
}

function onClickCB(obj) {
    var node = obj.nodes[0];
    menuClose();
    if (node && node.state!='unavailable') {
        var cv = interfaceGetCurrent();
        if (node.type === "section" && cv =='topview') {
            viewer.unselectAll();
            if(initialConfig.config.integrationType=='bumper'){
                viewer.goTo(node.id,viewer.min_scaling_factor*9.5,1000);
            }else{
                viewer.select(node.id);
                dvmLoadSeatmap(node);
            }
        } else if (node.type === "seat") {
            viewer.unselectAll();
            viewer.select(node.id);
            dvmLoadViewer3D(node);
        }
    }
    popoverDestroyAll();
}

function onZoomCB(obj){
    
}

function onZoomingPanning(obj){

}

function onLoadMinimapSuccess(obj) {
    dvmSetFullAvailability(obj.instance);
    viewer_mini.flags.panning = false;
    viewer_mini.flags.zooming = false;
    //viewer_mini.max_scaling_factor = 1;
    viewer_mini.flags.max_zoom_on_first_limit = false;
    viewer_mini.scaling_factor = viewer_mini.min_scaling_factor;
    if(!viewer_mini.getNodesByState("section","selected").length && interf.params.v360){
        let section = interf.params.v360.split("-")[0];
        viewer_mini.select(section)
    }
    return Promise.resolve(obj);
}

function onLoadD2MError(err) {
    console.log(err);

    if(interfaceGetCurrent()=='seatmap'){
        dvmLoadViewer3D(interf.topview.nodes_selected[0]);
    }
}

function onLoadD2MSuccess(obj) {
    if(viewer.getMapId() === initialConfig.config.topview_id){
        if(!interf.filtering.ref){ filteringInit(); }
        interfaceSetTopview();
        dvmOnLoadTopview(obj);
    } else {
        interfaceSetSeatmap();
        dvmOnLoadSeatmap(obj);
    }

    interfaceHomeBtnHide();
    interfaceViewer3DBtnsHide();

    interfaceBCSetColours();

    if(interfaceIsMobile()) {
        //interfaceZoomHide();
        interfaceMoveArrowsHide();
    }
}

function dvmHideLabs(){
    var labs = document.getElementsByClassName("mmc-labels");
    if(labs.length>0){
        for(var i = 0;i<labs.length;i++){
            labs[i].classList.add("hidden");
        }
    }
    return null;
}
function dvmShowLabs(){
    var labs = document.getElementsByClassName("mmc-labels");
    if(labs.length>0){
        for(var i = 0;i<labs.length;i++){
            labs[i].classList.remove("hidden");
        }
    }
    return null;
}
function dvmLoadSeatmap(node){

    interf.topview.nodes_selected = [node];

    viewer.loadMap({
        venue_id: initialConfig.config.venue_id,
        map_id: node.id
    })
    .then(onLoadD2MSuccess)
    .catch(onLoadD2MError);

    if (viewer_mini.isLoaded()) {
        viewer_mini.unselectAll();
    }
    interfaceMinimapShow();
    interfaceSetNodeBC(node);
    interfaceSetCurrent('seatmap');
    dvmSelectViewerMini(node.id);
    searchHide();
}

function dvmSelectViewerMini(id){
    minimap_load.then(function(){
        viewer_mini.unselectAll();
        viewer_mini.select(id.split("-")[0]);
        viewer_mini.goTo(id.split("-")[0],viewer_mini.min_scaling_factor*2.5,1000);
    })
}

function dvmLoadViewer3D(node){
    interfacesetViewer3D(node);
    interf.seatmap.nodes_selected = [node];
    interfaceNavigationHide();
    topnavbtnsHide();
    searchHide();

    var node3d = { venue_id: initialConfig.config.venue_id, view_id : node.id }
    interfaceLinkToShare(node);
    viewer_3d.open();
    viewer_3d.loadView3d(node3d).then(function(){
        interfaceZoomHide();
        interfaceFSBtnShow();
        interfaceHomeBtnShow();
        breadcrumbsMobileHide();
        interfaceShowShareBtn();
        if (viewer_3d.gallery.hasGallery()){
            interfaceGalleryBtnShow();
        }
        interfaceTicketsMobileBtnShow();
        // interfaceSetInitialNavigation();
        dvmNavigationUpdatePopup();
        dvmSelectViewerMini(node.id);
    });
    interfaceMinimapShow();
    return null;
}

function dvmSetBlockmapStyles(){
    var style = viewer.getStyles();
    if(style[0].section && style[0].section.available){
        style[0].section.available.normal.none.fillStyle = seat_styles.available.normal.fill;
        style[0].section.available.hover.none.fillStyle = seat_styles.available.hover.fill;
        style[0].section.selected.normal.none.fillStyle = seat_styles.selected.normal.fill;
        style[0].section.selected.hover.none.fillStyle = seat_styles.selected.hover.fill;
        
        style[0].section.available.normal.none.fillOpacity = seat_styles.available.normal.fillOpacity;
        style[0].section.available.hover.none.fillOpacity = seat_styles.available.hover.fillOpacity;
        style[0].section.selected.normal.none.fillOpacity = seat_styles.selected.normal.fillOpacity;
        style[0].section.selected.hover.none.fillOpacity = seat_styles.selected.hover.fillOpacity;

        style[0].section.available.normal.none.strokeStyle = seat_styles.available.normal.stroke;
        style[0].section.available.hover.none.strokeStyle = seat_styles.available.hover.stroke;
        style[0].section.selected.normal.none.strokeStyle = seat_styles.selected.normal.stroke;
        style[0].section.selected.hover.none.strokeStyle = seat_styles.selected.hover.stroke;
        
        style[0].section.available.normal.none.strokeOpacity = seat_styles.available.normal.strokeOpacity;
        style[0].section.available.hover.none.strokeOpacity = seat_styles.available.hover.strokeOpacity;
        style[0].section.selected.normal.none.strokeOpacity = seat_styles.selected.normal.strokeOpacity;
        style[0].section.selected.hover.none.strokeOpacity = seat_styles.selected.hover.strokeOpacity;
        viewer.setStyles(style);
    }
    return null;
}

function dvmSeatmapSetStyles(){
    var style = viewer.getStyles();
    if(style[0].seat && style[0].seat.available){
        style[0].seat.available.normal.none.fillStyle = seat_styles.available.normal.fill;
        style[0].seat.available.hover.none.fillStyle = seat_styles.available.hover.fill;
        style[0].seat.selected.normal.none.fillStyle = seat_styles.selected.normal.fill;
        style[0].seat.selected.hover.none.fillStyle = seat_styles.selected.hover.fill;
        
        style[0].seat.available.normal.none.fillOpacity = seat_styles.available.normal.fillOpacity;
        style[0].seat.available.hover.none.fillOpacity = seat_styles.available.hover.fillOpacity;
        style[0].seat.selected.normal.none.fillOpacity = seat_styles.selected.normal.fillOpacity;
        style[0].seat.selected.hover.none.fillOpacity = seat_styles.selected.hover.fillOpacity;

        style[0].seat.available.normal.none.strokeStyle = seat_styles.available.normal.stroke;
        style[0].seat.available.hover.none.strokeStyle = seat_styles.available.hover.stroke;
        style[0].seat.selected.normal.none.strokeStyle = seat_styles.selected.normal.stroke;
        style[0].seat.selected.hover.none.strokeStyle = seat_styles.selected.hover.stroke;
        
        style[0].seat.available.normal.none.strokeOpacity = seat_styles.available.normal.strokeOpacity;
        style[0].seat.available.hover.none.strokeOpacity = seat_styles.available.hover.strokeOpacity;
        style[0].seat.selected.normal.none.strokeOpacity = seat_styles.selected.normal.strokeOpacity;
        style[0].seat.selected.hover.none.strokeOpacity = seat_styles.selected.hover.strokeOpacity;
        viewer.setStyles(style);
    }
    return null;
}

function dvmOnLoadTopview(obj){
    dvmSetBlockmapStyles();
    interfaceHideTopguide();

    viewer.max_selection = 1;
    dvmSetFullAvailability(obj.instance);
    viewer.select(interf.topview.nodes_selected);

    filteringTopviewApply();
    interfaceLinkToShare();
    interfaceHideShareBtn();

    var snodes = viewer.getNodesByState("section","selected");
    if(snodes.length>0){
        interfaceSetNodeBC(snodes[0]);
    }

    if(interfaceIsMobile()) {
        $("#sections-mobile").val('default');
        $('#sections-mobile').selectpicker("refresh");
        $("#row-mobile").val('default');
        $('#row-mobile').selectpicker("refresh");
        $("#seat-mobile").val('default');
        $('#seat-mobile').selectpicker("refresh");
    } else {
        $("#sections").val('default');
        $('#sections').selectpicker("refresh");
        $("#row").val('default');
        $('#row').selectpicker("refresh");
        $("#seat").val('default');
        $('#seat').selectpicker("refresh");
    }

    topnavbtnsHide();
    interfaceSetCurrent("topview");
    if (initialConfig.config.search.includeSearch && !initialConfig.config.search.advancedSearch) {
        searchShow();
    }
    var sections = viewer.getNodesByType("section");
    for (var i = 0; i < sections.length; i++) {
        interf.topview.hash[sections[i].id] = sections[i].id;
    }

    return null;
}

function dvmOnLoadSeatmap(obj){
    interfaceShowTopguide();
    dvmSetFullAvailability(obj.instance);
    filteringSeatmapApply();
    interfaceHideShareBtn();
    // dvmSelectBestSeat();
    menuBtnHide();
    topnavbtnsShow();
    interfaceSetNodeBC({id:obj.instance.getMapId()});
    return null;
}
function dvmSelectBestSeat(){
    if(viewer.best_nodes){
        viewer.best_nodes.getBestNodes("seat",1).then(function(res){
            //viewer.scaling_factor = 40;
            viewer.goTo(res[0].id,65,900).then(function(){
                viewer.select(res);
                interfaceSetNodeBC(res[0]);
            })
        }).catch(function(e){
            console.log(e);
        });
    }
}

function dvmToggleFS(){
    viewer_3d.toggleFullscreen().then(function(){
        $(".dvm-v3d-button-fullscreen").addClass("hidden");
        
        if($(".dvm-v3d-main").hasClass("dvm-v3d-main-fullscreen")){

            if(interfaceIsMobile()){
                $(".dvm-v3d-bottom-center").append($(".fsclose-btn").removeClass("hidden"));
            }else{
                $(".dvm-v3d-top-right").append($(".fsclose-btn").removeClass("hidden"));
            }
        }else{
            $(".fsclose-btn").addClass("hidden");
            $(".interface-btns-desktop").append($(".fsclose-btn"));
        }
    });

}

function dvmSetFullAvailability(instance) {
    var node_types = instance.getTypesList();

    node_types.forEach(function(type) {
        var ntypes = instance.getNodesByType(type);
        if(ntypes.length>0){
            instance.setAvailability(type,ntypes);
        }
    });
    return null;
}


function dvmNavigationUpdatePopup(){
    var nav = interfaceGetNavigation();
    if(nav.to){
        viewer.getThumbnail(nav.to.id, initialConfig.config.venue_id,true).then(function(imgUrl){
            $("#navigation-popup").attr("style","background-image: url('"+imgUrl+"')");
            $(".navigation-popup-title p").text(nav.to.title);
            interfaceNavigationShow();
        }).catch(function(e){
            console.log(e);
        })
    }
}

function dvmViewer3dOnClickNavNode(obj) {
    var nav = obj.navigation;
    if (nav) {
        nav.reset_camera_rotation = false;
        viewer_3d.loadView3d(nav)
    }
}

function dvmNavigationGo(){
    var node = viewer.getNodesByState("seat","selected")[0];
    if(!node && interf.params.v360){
        node = {id: interf.params.v360};
    }
    interfacesetViewer3D(node);
    interf.seatmap.nodes_selected = [node];
    interfaceNavigationHide();

    var nav = interfaceGetNavigation();
    var node3d = { venue_id: initialConfig.config.venue_id, view_id : nav.to.id }
    viewer_3d.open();
    viewer_3d.loadView3d(node3d).then(function(){
        interfaceSetNavigationReverse();
        dvmNavigationUpdatePopup();
        interfaceZoomHide();
        interfaceFSBtnShow();
        interfaceHomeBtnShow();
        breadcrumbsMobileHide();

        if (viewer_3d.gallery.hasGallery()){
            interfaceGalleryBtnShow();
        }
        interfaceTicketsMobileBtnShow();

    });
}